import { Suspense } from "react";
import { XIcon } from "@/icons";
import { Badge } from "@/kit/ui/badge";
import { AuthorSchemaInput } from "./schema";
import EntityAvatar from "../EntityAvatar";
import ProfilePic from "../ProfilePic";

export interface AuthorProps {
  author: AuthorSchemaInput;
  onRemove: () => void;
}

export function Author({ author, onRemove }: AuthorProps) {
  if ("registered" in author) {
    return (
      <Badge>
        <Suspense fallback={<EntityAvatar.Skeleton />}>
          <EntityAvatar.Lazy id={author.registered.id} size="4" label="" />
        </Suspense>
        <button onClick={onRemove} type="button">
          <XIcon className="w-4 h-4" />
        </button>
      </Badge>
    );
  } else {
    return (
      <Badge>
        <div className="flex flex-row items-center justify-start gap-1.5">
          <ProfilePic className="w-4 h-4" alt={author.unregistered.fullName} />
          <span>{author.unregistered.fullName}</span>
          <button onClick={onRemove} type="button">
            <XIcon className="w-4 h-4" />
          </button>
        </div>
      </Badge>
    );
  }
}
